import styled from 'styled-components'
import BlankIconButton from './BlankIconButton'

const BlankIconButtonDelete = styled(BlankIconButton).attrs({
  type: 'circle-minus',
})``

export default BlankIconButtonDelete
